module.exports = __webpack_public_path__ + "static/media/ellipsis-h-alt.efc04d75.svg";